var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 73,
    viewBox: "0 0 80 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1136 19.5084V51M30.1136 19.5084L40.571 30.0056M30.1136 19.5084L19.6563 30.0056M49.2855 37.0037C54.5804 37.0037 58 32.6964 58 27.3813C57.9998 25.277 57.3125 23.2308 56.0433 21.5561C54.774 19.8813 52.9929 18.6704 50.9726 18.1088C50.6618 14.1844 49.0415 10.48 46.3738 7.59438C43.706 4.70878 40.1467 2.81069 36.2713 2.20698C32.3959 1.60326 28.4309 2.32921 25.0174 4.26745C21.6038 6.20569 18.9413 9.24294 17.4602 12.8881C14.3419 12.0205 11.0079 12.4318 8.19173 14.0316C5.37553 15.6314 3.3078 18.2887 2.4434 21.4189C1.579 24.5491 1.98875 27.8957 3.5825 30.7226C5.17625 33.5496 7.82346 35.6252 10.9418 36.4929",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b34a9648b3be1d00f8f8648916117983.svg";
export { ForwardRef as ReactComponent };